import { ThemeUICSSObject } from 'theme-ui';
import common from './common';

const primary: ThemeUICSSObject = {
  ...common('components.paginationPrimary'),
};

export default primary;
